import { Injectable, NgZone } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { catchError, of, tap } from "rxjs";
import { Me } from "../models/models";
import { DashboardService } from "./dashboard.service";

@Injectable({
    providedIn: 'root'
  })
  export class AuthService {
  
    meData: any | undefined;
    userData: any; // Save logged in user data
  constructor(
    private http: HttpClient,
    public router: Router,    
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    
  }

  StudiaSignIn(name: string, usernmame: string, email: string, password: string) :Promise<any>{

    return new Promise<any>((resolve, reject) => {

      const user: any= {id: "3fa85f64-5717-4562-b3fc-2c963f66afa6", 
        username: usernmame, 
        name : name,
        email: email, 
        password: password, 
        lang: "ES", 
        claims: [], 
        role: "superadmin"
      };

      this.http.post<any>(`${environment.authApiUrl}User`, user).subscribe({
        next:(result:any)=>{
          console.log("newuser", result);
          resolve(result);
        }, 
        error:(error:any)=>{
          reject(error);
        }
      });

    });
  }


  NenomedCustomerSignUp(email: string, password: string)
  {
    const login: any = {
      username: email,
      password: password
    };

    return this.http.post<any>(`${environment.nenomedCloudUrl}Authentication/login`, login);
  }

  NenomedRecoverPassword(email: string) {
    const user: any = { emailAddress: email };
    return this.http.post<any>(`${environment.nenomedCloudUrl}Register/ResetPassword`, user);
  }


  StudiaSignUp(email: string, password: string){
    
    const login: any= {token: "00000000-0000-0000-0000-000000000000", 
    username: email,     
    password: password,         
    roles: []
  };

    return this.http.post<any>(`${environment.authApiUrl}Authentication`, login);

  }

  StudiaRefreshToken(token: string, refreshToken: string){
    const authToken: any= {token: token, refreshToken: refreshToken };
    return this.http.post<any>(`${environment.authApiUrl}Authentication/Refresh`, authToken)
    .pipe(
      tap((token)=>{}),
      catchError((err)=>{
        localStorage.removeItem('nenomed-user');
        this.router.navigate(['auth/sign-in']);
        return of(false);
      }));
  }

  StudiaConfirmEmail(email: string, token: string){
    const tokenEncode = encodeURIComponent(token)
    return this.http.get<any>(`${environment.authApiUrl}User/ConfirmEmail?email=${email}&token=${tokenEncode}`);
  }

  StudiaResetPassword(email: string, password: string, token: string){
    const user : any = {email: email, password: password, token: token, lang: '', claims: []};
    
    return new Promise<any>((resolve, reject) => {    

      return this.http.post<any>(`${environment.authApiUrl}User/resetPwd`, user).subscribe({
        next:(result:any)=>{
          console.log("newuser", result);
          resolve(result);
        }, 
        error:(error:any)=>{
          reject(error);
        }
      });

    });
  }

  StudiaRecoverPassword(email: string) {
    
    const user : any = {email: email, password: '', token: '', lang: '', claims: []};
    return this.http.post<any>(`${environment.authApiUrl}User/recoveryPwd`, user);    
  }

  // Sign in with email/password
  
  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    try {
      const raw = localStorage.getItem('nenomed-user');
      if (!raw) return false;
      const user = JSON.parse(raw);
      return user !== null && user.AUTH_TOKEN !== "";
    } catch {
      return false;
    }
  }
  // Sign in with Google

  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(user: any) {
    // const userRef: AngularFirestoreDocument<any> = this.afs.doc(
    //   `users/${user.uid}`
    // );
    // const userData: User = {
    //   uid: user.uid,
    //   email: user.email,
    //   displayName: user.displayName,
    //   photoURL: user.photoURL,
    //   emailVerified: user.emailVerified,
    // };
    // return userRef.set(userData, {
    //   merge: true,
    // });
  }
  // Sign out
  SignOut() {
    
    localStorage.removeItem('nenomed-user');
    this.meData = undefined;
    this.router.navigate(['auth/login']);
  }

  // Añade este método auxiliar para construir el UserModel extendido
  buildUserModel(userData: any): any {
    const APP_CONFIG = { scwCloudUrl: environment.nenomedCloudUrl }; // Ajusta si tienes APP_CONFIG global
    const UserModel: any = { ...userData };

    UserModel.userId = userData.USUARIO_ID;
    UserModel.applicationVersion = userData.NENOMED_CURRENT_VERSION;
    UserModel.username = userData.USUARIO_EM;
    UserModel.assistant = userData.ASSISTANT_BL;
    UserModel.updatedate = userData.USUARIO_LOCAL?.PERSONAL?.MODIFY_DT;
    UserModel.IsGlobalAdmin = userData.USUARIO_LOCAL?.ADMIN_GLOBAL;
    UserModel.cuenta = userData.USUARIO_LOCAL?.CUENTAS;
    UserModel.centros = userData.USUARIO_LOCAL?.PERSONAL?.CENTROS_MEDICOS;

    UserModel.name = userData.USUARIO_LOCAL?.PERSONAL?.PERSONAL_NM;
    UserModel.personal_id = userData.USUARIO_LOCAL?.PERSONAL?.PERSONAL_ID;
    UserModel.lastname = userData.USUARIO_LOCAL?.PERSONAL?.PERSONAL_AP;
    UserModel.color = userData.USUARIO_LOCAL?.PERSONAL?.COLOR_CD;
    UserModel.cliente = userData.CLIENTE_CD;
    UserModel.videos_help = userData.USUARIO_LOCAL?.VIDEOS_HELP;

    UserModel.isDemoAccount = false;
    if (userData.CLIENT_TYPE === "DEMO") {
      UserModel.clientType = UserModel.cuenta?.CUENTA_CD;
      UserModel.isDemoAccount = true;
    } else {
      UserModel.clientType = userData.CLIENT_TYPE;
    }

    UserModel.expiredLicense = userData.LICENCIA_CADUCADA;
    UserModel.activationAccountDate = userData.ACTIVACION_CUENTA_DT;
    UserModel.inactiveAccountDate = userData.DESACTIVACION_CUENTA_DT;
    UserModel.usuario_local = userData.USUARIO_LOCAL_ID;
    UserModel.logIn = true;
    UserModel.notificationStatus = true;
    UserModel.mediaRootPath = APP_CONFIG.scwCloudUrl + "azure/";
    UserModel.mediaRootPathBlob = "https://scwcloud.blob.core.windows.net/";
    UserModel.mediaPublicPath = UserModel.mediaRootPath + "public/";
    UserModel.mediaPath = UserModel.mediaRootPath + (UserModel.cliente ? UserModel.cliente.substring(3, 9) : "") + "/";

    UserModel.centerAvatar = "centerIcon.png";

    // --- NUEVO BLOQUE: centro_actual y isClinicAdmin ---
    // Utils.getSingleInList: función auxiliar para encontrar el primer elemento que cumpla la condición
    function getSingleInList<T>(arr: T[], predicate: (item: T) => boolean): T | null {
      if (!Array.isArray(arr)) return null;
      for (const item of arr) {
        if (predicate(item)) return item;
      }
      return null;
    }

    if (UserModel.centros != null && UserModel.centros.length > 0) {
      UserModel.centro_actual = getSingleInList(UserModel.centros, (center: any) => center.FAVORITA_BL === true);
      if (UserModel.centro_actual == null) {
        UserModel.centro_actual = UserModel.centros[0];
      }
      const clinicFilter = UserModel.centro_actual.Roles?.filter((r: any) => r.ROLE_CD === "ROL000004");
      UserModel.isClinicAdmin = clinicFilter != null && clinicFilter.length > 0;
    } else {
      UserModel.centro_actual = null;
    }
    // --- FIN BLOQUE NUEVO ---
    
    // Avatar y foto de usuario
    if (UserModel.username === "ayuda@smartclinicweb.com") {
      // Puedes ajustar esto si tienes APP_CONFIG global
      // APP_CONFIG.PrintServerUrl = 'http://localhost:8181/';
      // console.log(APP_CONFIG.PrintServerUrl);
    }

    if (userData.USUARIO_LOCAL?.PERSONAL?.AVATAR_BL) {
      UserModel.picture = UserModel.mediaPath + "/PERSONAL/" + userData.USUARIO_LOCAL_ID + "/AVATAR/avatar.png"+"?height=" + 80 + "&width=" + 80;
    } else {
      UserModel.picture = userData.USUARIO_LOCAL?.PERSONAL?.AVATAR_NM+"?height=" + 80 + "&width=" + 80;
    }

    // Avatares por defecto
    const AVATARES = [
      {
        path: UserModel.mediaPublicPath + "male_doctor.png",
        name: "MALE",
        icon: "fa-male"
      },
      {
        path: UserModel.mediaPublicPath + "female_doctor.jpg",
        name: "FEMALE",
        icon: "fa-female"
      }
    ];
    const CUSTOMER_AVATARES = [
      {
        path: UserModel.mediaPublicPath + "male.png",
        name: "MALE",
        icon: "fa-male"
      },
      {
        path: UserModel.mediaPublicPath + "female.png",
        name: "FEMALE",
        icon: "fa-female"
      }
    ];
    UserModel.avatares = AVATARES;
    UserModel.customerAvatar = CUSTOMER_AVATARES;

    return UserModel;
  }

  }